import React, { memo, ReactNode } from 'react';
import { useTheme } from 'tamagui';

import CobuText from './CobuText';
import CobuStack from '../layout/CobuStack';

interface CobuHeaderProps {
  title?: string;
  titleComponent?: () => ReactNode;
  renderLeft?: () => ReactNode;
  renderRight?: () => ReactNode;
}

const HEADER_HEIGHT = 40;

const CobuHeader: React.FC<CobuHeaderProps> = memo(({
  title,
  titleComponent,
  renderLeft,
  renderRight,
}) => {
  const parentViewStyle = {
    backgroundColor: "$cardBackground",
  };

  // Left content
  const LeftContent = () => {
    if (!renderLeft) return null;
    return <>{renderLeft()}</>;
  };

  // Title content (left-aligned, behaves like default header title)
  const TitleContent = () => {
    if (!title && !titleComponent) return null;
    if (titleComponent) return titleComponent();
    return (
      <CobuText variant="subheading" fontSize="$4"
        fow="$semibold" numberOfLines={1} maxFontSizeMultiplier={1.25}>
        {title}
      </CobuText>
    );
  };

  return (
    <CobuStack layout="horizontal" ai="center" jc="space-between" px="$4" pt="$0" position="relative" style={{ height: HEADER_HEIGHT, ...parentViewStyle }}>
      {/* Left slot (auto width) */}
      <CobuStack layout="horizontal" ai="center">
        <LeftContent />
      </CobuStack>
      {/* Title (absolutely centered, independent of left/right widths) */}
      <CobuStack position="absolute" left={0} right={0} ai="center" pointerEvents="none">
        <TitleContent />
      </CobuStack>
      {/* Right slot (auto width, right-aligned) */}
      <CobuStack layout="horizontal" ai="center" jc="flex-end">
        {renderRight?.()}
      </CobuStack>
    </CobuStack>
  );
});

CobuHeader.displayName = 'CobuHeader';

export default CobuHeader;


